<template>
  <SectionCard
    id="scenario"
    :class="isPcFlag ? 'application-scenarios-pc' : 'application-scenarios-h5'"
    :isPcFlag="isPcFlag"
    title="应用场景"
    bgColor="#F6F7F9"
    :bgImg="isPcFlag ? bgImg : ''"
  >
    <div class="scenarios-content">
      <ul class="tab_title">
        <li v-for="(v, i) in dataList" :class="m == i ? 'active' : ''" @click="m = i" :key="i.title">
          {{ v.title }}
        </li>
      </ul>

      <!-- 内容 -->
      <div class="tab_content">
        <div class="content-item" v-for="(v, i) in dataList" v-show="m == i" :key="i">
          <div class="desc">
            <span class="desc-one">{{ v.descOne }}</span>
            <span v-if="isPcFlag">&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span v-else>&nbsp;&nbsp;</span>
            <span class="desc-two">{{ v.descTwo }}</span>
          </div>
          <img v-if="isPcFlag" class="img" :src="v.img" alt="" />
          <img v-else class="img" :src="v.imgH5" alt="" />
        </div>
      </div>
    </div>
  </SectionCard>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataList: Array,
  },
  components: {
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
  },
  data() {
    return {
      m: 0,
      bgImg: require('@/assets/images/landing-signet/yycj_bg.jpg'),
    }
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
// pc样式
.application-scenarios-pc {
  .scenarios-content {
    .columnDisplay(center,center);
    .tab_title {
      width: 100%;
      height: 60px;
      border-bottom: 1px solid #bdbdbd;
      .basisDisplay(center,center);
      li {
        margin: 0 86px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 60px;
        text-align: center;
        position: relative;
      }
      li:hover {
        cursor: pointer;
      }
      li.active {
        color: #e63740;
      }
      li.active::after {
        content: '';
        position: absolute;
        width: 91px;
        height: 4px;
        left: 50%;
        bottom: -1px;
        background-color: #e63740;
        transform: translateX(-50%);
      }
    }
    .tab_content {
      padding: 20px 42px;
      .desc {
        margin-bottom: 20px;
        .basisDisplay(center,center);
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }
    }
  }
}
.application-scenarios-h5 {
  .scenarios-content {
    .columnDisplay(center,center);
    .tab_title {
      width: 100%;
      height: 1.0667rem;
      border-bottom: 0.0267rem solid #bdbdbd;
      .basisDisplay(space-between,center);
      li {
        font-size: 0.3733rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        margin-bottom: 0.4267rem;
        position: relative;
      }
      li:hover {
        cursor: pointer;
      }
      li.active {
        color: #e63740;
      }
      li.active::after {
        content: '';
        position: absolute;
        width: 1.0667rem;
        height: 0.1067rem;
        left: 50%;
        bottom: -0.56rem;
        background-color: #e63740;
        transform: translateX(-50%);
      }
    }
    .tab_content {
      padding: 0.5333rem 0;
      .desc {
        margin-bottom: 0.64rem;
        flex-wrap: wrap;
        font-size: 0.3733rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.5867rem;
      }
    }
  }
}
// h5样式
</style>